import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HlmBadge } from '@spartan-ng/helm/badge';
import { HlmSidebarTrigger } from '@spartan-ng/helm/sidebar';
import { environment } from '../../../environments/environment';
import { version } from 'version';

@Component({
    selector: 'app-header',
    templateUrl: './app-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [HlmBadge, HlmSidebarTrigger],
})
export class AppHeaderComponent {
    public readonly title = input.required<string>();

    protected readonly version = version;
    protected readonly isDevelopment = !environment.production && !(environment as { stage?: boolean }).stage;
    protected readonly isStage = !!(environment as { stage?: boolean }).stage;
}
